import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { ChartPie, Users, AppWindow, LayoutTemplate, Bot, Globe, ArrowLeftToLine, ArrowRightToLine, Files, ImagePlus} from 'lucide-react';
import {Link} from "react-router-dom";

function MenuGroup({ id, icon: Icon, title, items }) {
    return (
        <div className="nav-item-wrapper">
            <a className="nav-link dropdown-indicator label-1 collapsed"
                href={`#${id}`}
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls={id}
            >
                <div className="d-flex align-items-center">
                    <div className="dropdown-indicator-icon-wrapper">
                        <FontAwesomeIcon icon={faCaretRight} className="dropdown-indicator-icon" />
                    </div>
                    <span className="nav-link-icon">
                        <Icon size={19} />
                    </span>
                    <span className="nav-link-text">{title}</span>
                </div>
            </a>

            <div className="parent-wrapper label-1">
                <ul className="nav collapse parent" data-bs-parent="#navbarVerticalCollapse" id={id}>
                    <li className="collapsed-nav-item-title d-none">{title}</li>
                    {items.map((item, index) => (
                        <li className="nav-item" key={index}>
                            <Link className="nav-link" to={item.to}>
                                <div className="d-flex align-items-center">
                                    <span className="nav-link-text">{item.text}</span>
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

function LeftSideBarAdmin() {
    const menuGroups = [
        {
            groupTitle: "APPS",
            menus: [
                {
                    id: "nv-UserManagement",
                    title: "User Management",
                    icon: Users,
                    items: [
                        { text: "User Information", to: "/ai-chatbot/administrator/apps/user-management/user-information" },
                        { text: "User Role", to: "/ai-chatbot/administrator/apps/user-management/user-role" },
                        { text: "User Visitor", to: "#" },
                    ],
                },
                {
                    id: "nv-SystemManagement",
                    title: "System Management",
                    icon: AppWindow,
                    items: [
                        { text: "Appointment", to: "/ai-chatbot/administrator/apps/system-management/appointment" },
                        { text: "Notification", to: "#" },
                        { text: "Application Parameter", to: "/ai-chatbot/administrator/apps/system-management/app-params" },
                        { text: "Mailjet Management", to: "/ai-chatbot/administrator/apps/system-management/mailjet" },
                    ],
                },
                {
                    id: "nv-Template",
                    title: "Template",
                    icon: LayoutTemplate,
                    items: [
                        { text: "Email Template", to: "/ai-chatbot/administrator/apps/template/email-template" },
                        { text: "Noti InApp Template", to: "/ai-chatbot/administrator/apps/template/noti-inapp-template" },
                        { text: "AWS QnA Chatbot Testing", to: "/ai-chatbot/administrator/apps/template/aws-testing" },
                    ],
                },
            ],
        },
        {
            groupTitle: "PAGES",
            menus: [
                {
                    id: "nv-LandingPage",
                    title: "Landing Page",
                    icon: Globe,
                    items: [
                        { text: "Article", to: "/ai-chatbot/administrator/pages/landing-page/article" },
                        { text: "Private Blog Post", to: "/ai-chatbot/administrator/pages/landing-page/private-blog-post" },
                        { text: "Route", to: "/ai-chatbot/administrator/pages/landing-page/route" },
                        { text: "Our Service", to: "/ai-chatbot/administrator/pages/landing-page/our-service" },
                    ],
                },
                {
                    id: "nv-AIChatbotPage",
                    title: "AI Chatbot Page",
                    icon: Bot,
                    items: [
                        { text: "Service Manager", to: "/ai-chatbot/administrator/pages/ai-chatbot-page/service-manager" },
                        { text: "AWS User Chat Manager", to: "/ai-chatbot/administrator/pages/ai-chatbot-page/aws-chat-manager" },
                        { text: "Support Case Assistant", to: "/ai-chatbot/administrator/pages/ai-chatbot-page/support-case" },
                        { text: "Support Case History", to: "/ai-chatbot/administrator/pages/ai-chatbot-page/support-case-history" },
                        { text: "Payment Information", to: "/ai-chatbot/administrator/pages/ai-chatbot-page/payment-information" },
                        { text: "User Plan Subscription", to: "/ai-chatbot/administrator/pages/ai-chatbot-page/user-plan-subscription" },
                    ],
                },
            ],
        },
    ];

    const menus = [
        {title: "Dashboard", icon: ChartPie, to: "/ai-chatbot/administrator"},
        {title: "File Manager", icon: Files, to: "/ai-chatbot/administrator/file-manager"},
        {title: "Page Route", icon: Files, to: "/ai-chatbot/administrator/page-route"},
        {title: "Assets Image", icon: ImagePlus, to: "/ai-chatbot/administrator/assets-image"},
    ]

    const handleToggleCollapse = () =>{
        const html = document.documentElement; // <html>
        html.classList.toggle("navbar-vertical-collapsed");
    }

    return (
        <nav className="navbar navbar-vertical navbar-expand-lg">
            <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
                <div className="navbar-vertical-content">
                    <ul className="navbar-nav flex-column" id="navbarVerticalNav">
                        {
                            menus.map((item, index) => {
                                let Icon = item.icon;
                                return (
                                    <li className="nav-item" key={index}>
                                        <div className="nav-item-wrapper">
                                            <Link className="nav-link label-1" to={item.to} role="button"
                                                  data-bs-toggle="" aria-expanded="false">
                                                <div className="d-flex align-items-center">
                                            <span className="nav-link-icon">
                                                <Icon size={19}/>
                                            </span>
                                                    <span className="nav-link-text-wrapper">
                                                <span className="nav-link-text fs-8-1">{item.title}</span>
                                            </span>
                                                </div>
                                            </Link>
                                        </div>
                                    </li>
                                )
                            })
                        }
                        {menuGroups.map((group, gIndex) => (
                            <li className="nav-item" key={gIndex}>
                                <p className="navbar-vertical-label">{group.groupTitle}</p>
                                <hr className="navbar-vertical-line" />
                                {group.menus.map((menu) => (
                                    <MenuGroup key={menu.id} {...menu} />
                                ))}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="navbar-vertical-footer">
                <button onClick={handleToggleCollapse} className="btn navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center">
                    <ArrowLeftToLine size={19} />
                    <ArrowRightToLine size={19} />
                    <span className="navbar-vertical-footer-text ms-2">Collapsed View</span>
                </button>
            </div>
        </nav>
    )
}

export default LeftSideBarAdmin;